<template>
  <div>
    <my-notification :icon="'joomla'">
      <template #title>
        {{ $t('compEcolabwareDocsTeam.title-1') }}
      </template>
      <div>
        <ul class="bcteam">
          <li>Max-Henri Chanut : <em>INRAE, Paris</em></li>
          <li>Sophie Schbath : <em>INRAE, Paris</em></li>
          <li>Marianne De Paepe : <em>INRAE, Paris</em></li>
        </ul>
      </div>
    </my-notification>
    <br />
    <my-notification :icon="'cogs'">
      <template #title>
        {{ $t('compEcolabwareDocsTeam.title-2') }}
      </template>
      <div>
        <ul class="bcteam">
          <li>Cédric Midoux : <em>INRAE, Paris</em></li>
        </ul>
      </div>
    </my-notification>
    <br />
    <my-notification :icon="'keyboard-o'">
      <template #title>
        {{ $t('compEcolabwareDocsTeam.title-3') }}
      </template>
      <div>
        <ul class="bcteam">
          <li>Jérôme Mariette : <em>INRAE, Toulouse</em></li>
        </ul>
      </div>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Team',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>

<style lang="css" scoped>
.bcteam {
  list-style-type: square;
  margin-left: 25px;
}
.bcteam > li {
  padding-top: 5px;
}
</style>
